import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';

import '../SideNav.scss';
import MenuItem from './MenuItem';

type Props = {
  societyId: string;
};

const DocumentsMenu: FC<Props> = ({ societyId }) => {
  const { t } = useTranslate();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey="8">
        <li className="nk-menu-item has-sub">
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-files" />
            </span>
            <span className="nk-menu-text">{t('Documents')}</span>
          </a>
        </li>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="8">
        <ul className="nk-menu-sub">
          <MenuItem linkTo={`/documentos/${societyId}`} text="Documents" />
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default DocumentsMenu;
